module.exports = __webpack_public_path__ + "static/img/row2.6c41f8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-mini/row2.png
// module id = 7t+o
// module chunks = 12